import React, { Fragment } from 'react';

// 電話番号登録済のデザイン
function getDesign(stateOtpChange, radioChange, messageListOtpChange) {

  return (
    <Fragment>
      <div className="listOnetimePass__item">
        <div className="listOnetimePass__radio">
          <label className="ds-radio">
            <input className="ds-radio__input" type="radio" name="address" id="LA-input-tel"
              aria-describedby="WA_address-2 WA_address-text-2" value="1" onClick={radioChange} />
            <span className="ds-radio__partsWrap">
              <span className="ds-radio__parts" role="none"></span>
              <span className="ds-radio__text">{messageListOtpChange.M013_otpNoticesMobileNumber}</span>
            </span>
          </label>
        </div>
        <div className="listOnetimePass__detail">
          <div id="WA_address-2" className="listOnetimePass__address">{stateOtpChange.phonenumber}</div>
          <p id="WA_address-text-2" className="ds-text listOnetimePass__text">
            {messageListOtpChange.M014_mobileNumberChangeText001}<br />
            {messageListOtpChange.M016_mobileNumberChangeText003}
          </p>
          <div className="ds-button ds-button--tertiary ds-button--small">
            <a className="ds-button__trigger"
               href={`${process.env.REACT_APP_CONTEXT_PATH}/mobilenumber_change?design=` + sessionStorage.getItem('design') + "&lang=" + sessionStorage.getItem('lang')}
               aria-describedby="WA_address-2">
              <span className="ds-button__label">{messageListOtpChange.M017_mobileNumberChangeText004}</span>
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export { getDesign }
